import React from 'react';
import { statusBadgeClass } from '../../utils/agentPlatformLabels';

type Props = {
  status: unknown;
  label: string;
  kind?: 'agent' | 'flow' | 'execution';
};

export const StatusBadge: React.FC<Props> = ({ status, label, kind = 'agent' }) => (
  <span
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ring-1 ring-inset ring-black/5 ${statusBadgeClass(status, kind)}`}
  >
    {label}
  </span>
);
